import { createSlice } from "@reduxjs/toolkit";

// Ensures that when the org is switched, the value is retained even after refresh.
const currentOrg = window?.localStorage.getItem("REDUX_CURRENT_ORGANIZATION")
  ? window?.localStorage.getItem("REDUX_CURRENT_ORGANIZATION")
  : window?.localStorage.getItem("REDUX_DEFAULT_ORGANIZATION");

const initialState = {
  defaultOrganization: null,
  currentOrganization: JSON.parse(currentOrg),
  organizations: [],
};

export const organizationSlice = createSlice({
  name: "organization",
  initialState,
  reducers: {
    setDefaultOrganization: (state, action) => {
      window?.localStorage.setItem(
        "REDUX_DEFAULT_ORGANIZATION",
        JSON.stringify(action.payload)
      );
      state["defaultOrganization"] = action.payload;
    },
    setCurrentOrganization: (state, action) => {
      window?.localStorage.setItem(
        "REDUX_CURRENT_ORGANIZATION",
        JSON.stringify(action.payload)
      );
      state["currentOrganization"] = action.payload;
    },
    setOrganizations: (state, action) => {
      state["organizations"] = action.payload;
    },
    reset: () => initialState,
  },
});
